import * as common from '@/utils/common';
import { bizmatesApi } from '@/utils/bizmatesApi';
import { contractTypes, errorCodes } from '@/utils/constants';
import { jwtHelperMyStage } from '@/utils/jwt';
import logger from '@/modules/Logger';
import { getApiMethod } from '@/modules/apiSelector';

export default {
  namespaced: true,
  state: {
    userId: null,
    userType: null,
    userToken: null,
    userContractType: null,
    htmlCss: null,
    htmlBody: null,
    htmlLevelName: null,
    htmlLevel: null,
    htmlRank: null,
    htmlLessonId: null,
    htmlTitle: null,
    htmlLessonNo: null,
    htmlPdfUrl: null,
    htmlUrl: null,
    htmlIsRevamp: null,
    htmlHasPrefix: null,
    htmlTrainerMaterials: []
  },
  getters: {
    isTrainer: state => {
      return state.userType === 't';
    },
    isStudent: state => {
      return state.userType === 's';
    },
    isB2B2C: state => {
      const contract = contractTypes.find(key => key.id === state.userContractType);
      return contract?.label === 'B2B2C';
    }
  },
  mutations: {
    /**
     * Decode User Token
     *
     * @param {*} state
     * @param {*} token
     */
    setUserInfo(state, token) {
      state.userToken = token.data.token;

      const userinfo = jwtHelperMyStage.verify(token.data.token);

      if (!userinfo) {
        common.redirectToHome(errorCodes.ME003);
      }

      state.userId = userinfo.id;
      state.userType = userinfo.user_type;
      state.userContractType = userinfo?.contract_type;
    },

    /**
     * Set HTML Material Contents
     *
     * @param {*} state
     * @param {*} payload
     */
    setHtmlMaterial(state, payload) {
      state.htmlCss = payload.css;
      state.htmlBody = payload.content;
      state.htmlLevelName = payload.level;
      state.htmlLevel = payload.level_id;
      state.htmlRank = payload.rank;
      state.htmlLessonId = payload.lesson_id;
      state.htmlTitle = payload.title;
      state.htmlLessonNo = payload.no;
      state.htmlPdfUrl = payload.pdf_url;
      state.htmlUrl = payload.html_url;
      state.htmlIsRevamp = payload.is_revamp;
      state.htmlHasPrefix = payload.has_prefix;
    },

    /**
     * Reset HTML Material Contents
     *
     * @param {*} state
     * @param {*} payload
     */
    resetHtmlMaterial(state) {
      state.htmlCss = null;
      state.htmlBody = null;
      state.htmlLevelName = null;
      state.htmlLevel = null;
      state.htmlRank = null;
      state.htmlLessonId = null;
      state.htmlTitle = null;
      state.htmlLessonNo = null;
      state.htmlPdfUrl = null;
      state.htmlUrl = null;
      state.htmlIsRevamp = null;
      state.htmlHasPrefix = null;
    },

    /**
     * Set Trainer HTML Material Contents
     *
     * @param {*} state
     * @param {*} payload
     */
    setHtmlTrainerMaterials(state, payload) {
      state.htmlTrainerMaterials = payload
      state.htmlIsRevamp = true;
    }
  },
  actions: {
    /**
     * Get User Token
     *
     * @param {*} commit
     */
    async getUserToken({ commit }) {
      await bizmatesApi.get('lessonmaterials/token', {}, response => {
        commit('setUserInfo', response.data);
      }, () => {
        common.redirectToHome(errorCodes.ME004);
      });
    },

    /**
     * Get HTML Material
     *
     * @param {*} state
     * @param {*} token
     */
    async getHtmlMaterial({ commit }, params) {
      const apiMethod = getApiMethod('getHtmlData');
      await apiMethod(params, (htmlMaterialData) => {
        const { level, rank, no } = htmlMaterialData || {};
      
        logger.info(`Loading HTML Material: ${level} ${rank}: Lesson ${no}`, {
          operation: 'materials:load-html-material'
        });
      
        if (htmlMaterialData && htmlMaterialData.lesson_id && htmlMaterialData.content) {
          commit('setHtmlMaterial', htmlMaterialData);
        }
      });
    },

    /**
       * Get Trainer Rank/Lesson HTML Materials
       *
       * @param {*} state
       * @param {*} token
       */
    async getHtmlTrainerMaterials({ commit }, params) {
      await bizmatesApi.get('lessonmaterials/trainer_html.json', { params }, response => {
        logger.info('Loading trainer HTML material', {
          operation: 'materials:trainer-html-lesson',
          payload: { rank_id: params.r, lesson_id: params.l }
        });
        if (params.tl) {
          commit('setHtmlMaterial', response.data);
          return;
        }
        commit('setHtmlTrainerMaterials', response.data);

      });
    }
  }
};
